import { Component, OnInit } from '@angular/core';
import {
  NtapCommonComponent,
  NtapGlobalConstants,
  UIComponents,
  Util
} from '@ntap/core';
import { Subscription } from 'rxjs';

import { ParentItemProviderService } from '@app/shared';

@Component({
  selector: 'app-napomena-izlucivanje-lista',
  templateUrl: './napomena-izlucivanje-lista.component.html',
  providers: [ParentItemProviderService]
})
export class NapomenaIzlucivanjeListaComponent
  extends NtapCommonComponent
  implements OnInit
{
  INIT_COMP_ID = UIComponents.LISTVIEW;

  currentListViewName: string;
  currentListViewState: object | null = null;
  currentListViewStateFilter: object = {};

  parentItem: any;

  routeChangeSubscription: Subscription;

  constructor(protected parentItemProvider: ParentItemProviderService) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.parentItemProvider.parentItem$.subscribe((parentItem) => {
        this.parentItem = parentItem;
        this.changeView('lista_napomena_izlucivanje', parentItem);
      })
    );
  }

  changeView(viewName: string, parentItem: any) {
    this.currentListViewName = viewName;
    this.currentListViewState = {
      [Util.getFullAttrName('en.izlucivanje', 'id')]:
        parentItem[
          Util.getFullAttrName(
            parentItem[NtapGlobalConstants.ATTR_$mainType],
            NtapGlobalConstants.ATTR_id
          )
        ]
    };
    this.currentListViewStateFilter = {};
  }
}
